import * as React from 'react';
import { DATA_HOOKS } from './constants';
import { st, classes } from './CounterBadge.st.css';
import { CounterBadgePriority, } from './types';
class CounterBadge extends React.Component {
    render() {
        const { priority, maximum, className, value } = this.props;
        const isMaximumNumber = value > maximum;
        const numberToPresent = isMaximumNumber ? `+${maximum}` : `${value}`;
        return (React.createElement("div", { className: st(classes.root, classes[`priority-${priority}`], className), "data-priority": priority, "data-hook": this.props['data-hook'] },
            React.createElement("div", { className: st(classes.innerContainer, {
                    maximumNumber: isMaximumNumber,
                }), "data-hook": DATA_HOOKS.VALUE }, numberToPresent)));
    }
}
CounterBadge.displayName = 'CounterBadge';
CounterBadge.defaultProps = {
    priority: CounterBadgePriority.primary,
    maximum: 99,
};
export { CounterBadge };
//# sourceMappingURL=CounterBadge.js.map